import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
  DataTable,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import moment from "moment";
import { capitalizeFirstLetter } from "../../../Helpers";

const CourseSubscriberDetails = () => {
  const { id, subscriberId } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [result, setResult] = useState("");
  const [ts, setTs] = useState("");
  const [transactions, setTransactions] = useState(null);

  useEffect(() => {
    fetchData();
  }, [ts]);
  async function fetchData() {
    let responseItem = "";
    let responseTransactions = "";
    try {
      responseItem = await axios.get(
        `/courses/${id}/subscribers/${subscriberId}`
      );
      setResult(responseItem.data.data);
    } catch (error) {
      console.log(error);
    }
    // try {
    //   responseTransactions = await axios.get(`/app/users/${id}/logs`);
    //   responseTransactions.data.data &&
    //     responseTransactions.data.data.lenght &&
    //     setTransactions(
    //       responseTransactions.data.data.map((item, index) => [
    //         item?.event ? item?.event : "-",
    //         item?.description ? item?.description : "-",
    //         item?.created_at
    //           ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
    //           : "-",
    //       ])
    //     );
    // } catch (error) {
    //   console.log(error);
    // }
  }
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Amount has been added successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  const switchStatusColor = (param) => {
    switch (param) {
      case "pending":
        return `default`;
      case "confirmed":
        return `success`;
      case "cancelled":
        return `warning`;
      case "cancelled with charge":
        return `critical`;
      default:
        return "";
    }
  };

  const switchStatusColorBooking = (param) => {
    switch (param) {
      case "pending":
        return `default`;
      case "confirmed":
        return `success`;
      case "cancelled":
        return `warning`;
      case "cancelled with charge":
        return `warning`;
      case "failed":
        return `critical`;
      default:
        return "";
    }
  };
  return result ? (
    <Page
      // narrowWidth
      backAction={{
        onAction: () => navigate(`/admin/courses/${id}/subscribers`),
      }}
      title={`${result?.first_name ? result?.first_name : ""} ${
        result?.last_name ? result?.last_name : ""
      }`}
      titleMetadata={
        <Badge tone={switchStatusColor(result?.course_booking?.status)}>
          {result?.course_booking?.status}
        </Badge>
      }
    >
      <FormLayout>
        <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              SUBSCRIBER DETAILS
            </Text>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>First Name</b>
                <br /> {result?.first_name ? result?.first_name : "-"}
              </Text>
              <Text breakWord>
                <b>Last Name</b>
                <br /> {result?.last_name ? result?.last_name : "-"}
              </Text>
              <Text>
                <b>Email</b>
                <br /> {result?.email ? result?.email : "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text breakWord>
                <b>Nationality</b>
                <br /> {result?.nationality ? result?.nationality : "-"}
              </Text>
              <Text breakWord>
                <b>Phone Number</b>
                <br /> {result?.phone_number ? result?.phone_number : "-"}
              </Text>
              <Text breakWord>
                <b>Start date</b>
                <br />
                {result?.created_at
                  ? moment(result?.created_at).format("YYYY-MM-DD HH:mm:ss")
                  : "-"}
              </Text>
            </FormLayout.Group>

            {/* {result?.classes_included && result?.classes_included?.length ? (
              <FormLayout>
                <Text variant="headingSm" as="h6">
                  CLASSES INCLUDED
                </Text>
                <DataTable
                  columnContentTypes={["text", "text", "text", "text"]}
                  headings={[
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Classes
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Remaining free bookings per month
                    </Text>,

                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Total bookings count
                    </Text>,
                  ]}
                  rows={
                    result?.classes_included?.length &&
                    result?.classes_included.map((item, index) => [
                      item.class_list?.map((item) => item.name).join(", "),
                      item?.remaining_free_bookings_per_month !== null
                        ? item?.remaining_free_bookings_per_month
                        : "-",
                      item?.total_bookings_count !== null
                        ? item?.total_bookings_count
                        : "-",
                    ])
                  }
                  verticalAlign="middle"
                  increasedTableDensity
                  hasZebraStripingOnData
                />
              </FormLayout>
            ) : null}
            {result?.session_bookings && result?.session_bookings?.length ? (
              <FormLayout>
                <Text variant="headingSm" as="h6">
                  BOOKINGS
                </Text>
                <DataTable
                  columnContentTypes={["text", "text", "text", "text"]}
                  headings={[
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Class
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Session Date
                    </Text>,
                    // <Text variant="bodyMd" as="p" fontWeight="medium">
                    //   Free bookings per month
                    // </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Booked Price
                    </Text>,
                    // <Text variant="bodyMd" as="p" fontWeight="medium">
                    //   Remaining Bookings
                    // </Text>,
                    // <Text variant="bodyMd" as="p" fontWeight="medium">
                    //   Limited / Unlimited
                    // </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Status
                    </Text>,
                    <Text variant="bodyMd" as="p" fontWeight="medium">
                      Created at
                    </Text>,
                  ]}
                  rows={result?.session_bookings.map((item, index) => [
                    item?.class_membership_info?.class_name
                      ? item?.class_membership_info?.class_name
                      : "-",
                    item?.session_date ? item?.session_date : "-",
                    // item?.class_membership_info?.free_bookings_per_month !==
                    // null
                    //   ? item?.class_membership_info?.free_bookings_per_month
                    //   : "-",
                    item?.amount !== null ? item?.amount : "-",
                    // item?.class_membership_info?.remaining_bookings !== null
                    //   ? item?.class_membership_info?.remaining_bookings
                    //   : "-",
                    // item?.class_membership_info?.is_limited
                    //   ? item?.class_membership_info?.is_limited
                    //   : "-",
                    item?.status ? (
                      <Badge tone={switchStatusColorBooking(item.status)}>
                        {capitalizeFirstLetter(item.status)}
                      </Badge>
                    ) : (
                      "-"
                    ),
                    item?.created_at
                      ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
                      : "-",
                  ])}
                  verticalAlign="middle"
                  increasedTableDensity
                  // truncate
                  // footerContent={
                  //   pageObject.tableItems?.length &&
                  //   `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
                  // }
                  hasZebraStripingOnData
                />
              </FormLayout>
            ) : null} */}
          </FormLayout>
        </Card>
        {/* <Card>
          <FormLayout>
            <Text variant="headingSm" as="h6">
              TRANSACTIONS
            </Text>

            {transactions?.length ? (
              <DataTable
                columnContentTypes={["text", "text", "text", "text"]}
                headings={[
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Event
                  </Text>,
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Description
                  </Text>,
                  <Text variant="bodyMd" as="p" fontWeight="medium">
                    Created at
                  </Text>,
                ]}
                rows={transactions}
                verticalAlign="middle"
                increasedTableDensity
                // truncate
                // footerContent={
                //   pageObject.tableItems?.length &&
                //   `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
                // }
                hasZebraStripingOnData
              />
            ) : transactions !== null ? (
              <Text>No transactions found for this user</Text>
            ) : null}
          </FormLayout>
        </Card> */}
      </FormLayout>
      {/* <PageActions
        secondaryActions={
          <Button
            variant="primary"
            loading={isSaving}
            tone="critical"
            onClick={() => {
              setIsSaving(true);
              axios
                .delete(`/app/users/${id}`)
                .then((result) => {
                  navigate("/admin/users");
                })
                .catch((err) => console.log(err));
            }}
          >
            Delete
          </Button>
        }
      /> */}
      {toastMarkup}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default CourseSubscriberDetails;
